export const violet = "#21014b";
export const soft_violet = "#8d7da5";
export const orange = "#ee8c3f";
export const soft_blue = "#7c76b5";
export const green = "#6FCF97";
export const red = "#FF2F43";
export const purple = "#861DF0";
export const day_purple = "#aba7cc";
export const dark_purple = "#21014C";
